export default function LogoSpinner({ size = 40 }: { size?: number }) {
  const ringSize = size;
  const logoSize = size * 0.55;
  return (
    <div className="logo-spinner-wrap" style={{ width: ringSize, height: ringSize }}>
      <img
        src="/assets/images/Untitled-5.png"
        alt="Loading"
        style={{ width: logoSize, height: logoSize }}
        className="object-contain relative z-10"
      />
      <div className="logo-glow-ring" />
    </div>
  );
}
